import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

class AstroIntelligenceClient {
  constructor() {
    this.baseURL = `${API_BASE_URL}/astro-intelligence`;
  }

  async getTradingSignals(symbols, birthData) {
    try {
      const response = await axios.post(`${this.baseURL}/trading-signals`, {
        symbols,
        birth_data: birthData
      });
      return response.data;
    } catch (error) {
      console.error('Error getting trading signals:', error);
      throw new Error(error.response?.data?.detail || 'Failed to get trading signals');
    }
  }

  async getPortfolioAnalysis(portfolio, birthData) {
    try {
      const response = await axios.post(`${this.baseURL}/portfolio-analysis`, {
        portfolio,
        birth_data: birthData
      });
      return response.data;
    } catch (error) {
      console.error('Error getting portfolio analysis:', error);
      throw new Error(error.response?.data?.detail || 'Failed to get portfolio analysis');
    }
  }

  async getMarketTiming(birthData) {
    try {
      const response = await axios.post(`${this.baseURL}/market-timing`, birthData);
      return response.data;
    } catch (error) {
      console.error('Error getting market timing:', error);
      throw new Error(error.response?.data?.detail || 'Failed to get market timing');
    }
  }

  async getPlanetaryPositions(birthData) {
    try {
      const response = await axios.post(`${this.baseURL}/planetary-positions`, birthData);
      return response.data;
    } catch (error) {
      console.error('Error getting planetary positions:', error);
      throw new Error(error.response?.data?.detail || 'Failed to get planetary positions');
    }
  }

  async checkApiStatus() {
    try {
      const response = await axios.get(`${this.baseURL}/api-status`);
      return response.data;
    } catch (error) {
      console.error('Error checking API status:', error);
      throw new Error(error.response?.data?.detail || 'Failed to check API status');
    }
  }

  async healthCheck() {
    try {
      const response = await axios.get(`${this.baseURL}/health`);
      return response.data;
    } catch (error) {
      console.error('Error checking health:', error);
      throw new Error(error.response?.data?.detail || 'Failed to check health');
    }
  }
}

export const astroIntelligenceClient = new AstroIntelligenceClient();
